<template>
  <div class="product-container">
    <router-view class="router-container" />

  </div>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>
.product-container {
  .router-container {
    padding: 20px;
  }
}
</style>

